
// ------------------------------------------------------
// ----------------- Keylooks ----------------------
// ------------------------------------------------------

if (document.querySelector(".keylooks-container")) {

      const images = document.querySelectorAll(".keylooks-container__item");
      const button = document.querySelector(".toggle-button");
      const imageContainer = document.querySelector(".keylooks-container__body");

      if (document.querySelector(".btnR")) {
            // La 2e version de la postShow
            button.addEventListener("click", function () {
                  if (!imageContainer.classList.contains("expanded")) {
                        imageContainer.classList.add("expanded");
                        for (let i = 0; i < images.length; i++) {
                              images[i].classList.add("show");
                        }
                        button.style.display = "none";
                        document.querySelector(".btnR").style.display = "block";
                  }
            });
      }
}